import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';

import { WaitImageComponent } from 'app/shared/components/wait-image.component/wait-image.component';
import { ComponentInfoComponent } from 'app/shared/components/component-info/component-info.component';
import { CancelWarningsTableComponent } from 'app/shared/components/cancel-warnings-table.component/cancel-warnings-table.component';
import { NumeralPipe } from 'app/shared/pipes/numeral.pipe';

@NgModule({
    imports: [CommonModule, TranslateModule.forChild(), FormsModule],
    declarations: [
        WaitImageComponent,
        NumeralPipe,
        ComponentInfoComponent,
        CancelWarningsTableComponent
    ],
    exports: [
        WaitImageComponent,
        NumeralPipe,
        ComponentInfoComponent,
        CancelWarningsTableComponent
    ]
})
export class SharedModule {
}



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts